import React from 'react';
import styles from './index.module.scss';

export default ({ children }) => {
  return (
    <div className={styles.layout}>
      <div className="flex-column flex-space-around width-450 mfullwidth height-330 flex-y-center">
        <div className="width-350 flex-row flex-space-evenly">
          <div className="bg-cover" style={{ backgroundImage: 'url(/images/smallAmaz.png)', width: '50px', height: '50px' }} />
          <div className="h1">AMAZ PORTAL</div>
        </div>
        <div className="width-100p height-auto">
          {children}
        </div>
      </div>
    </div>
  );
};
